import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '@/views/LoginPage.vue';
import HomePage from '@/views/HomePage.vue';
import DeviceDetailsPage from '@/views/DeviceDetailsPage.vue';
import DashboardLayout from '@/views/DashboardLayout.vue';
import UnauthorizedPage from '@/views/UnauthorizedPage.vue';
import keycloak from '@/keycloak';
import { frontendUrl } from '@/config/envVariablesConfig';
import AdminPage from '@/views/AdminPage.vue';

const routes = [
  {
    path: '/',
    name: 'LoginPage',
    component: LoginPage,
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: UnauthorizedPage,
  },
  {
    path: '/devices',
    component: DashboardLayout,
    meta: {
      requiresAuth: true,
      requiredRealmRoles: ['repairmen']
    },
    children: [
      {
        path: '',
        name: 'HomePage',
        component: HomePage,
      },
      {
        path: ':id', // The device ID parameter
        name: 'DeviceDetails',
        component: DeviceDetailsPage,
        props: true,
      },
    ],
  },
  {
    path: '/admin',
    component: DashboardLayout,
    meta: {
      requiresAuth: true,
      requiredRealmRoles: ['administrator'] // Only users with the 'administrator' role can access
    },
    children: [
      {
        path: '',
        redirect: { name: 'AdminPage' },
      },
      {
        path: 'admin-page',
        name: 'AdminPage',
        component: AdminPage,
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/', // Catch-all route to redirect unknown paths to the login page
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.name === 'Unauthorized') return next(); // don't guard the error page

  if (to.meta.requiresAuth && !keycloak.authenticated) {
    const redirectUri = new URL(to.fullPath, frontendUrl.replace(/\/?$/, '/')).toString();
    return keycloak.login({ redirectUri });
  }

  if (to.meta.requiredRealmRoles) {
    try { await keycloak.updateToken?.(30); } catch { void 0; }
    const required = Array.isArray(to.meta.requiredRealmRoles)
      ? to.meta.requiredRealmRoles
      : [to.meta.requiredRealmRoles];
    const roles = keycloak.tokenParsed?.realm_access?.roles || [];
    const has = required.some(r => roles.includes(r));
    if (!has) return next({ name: 'Unauthorized' });
  }

  next();
});


export default router;
